import * as React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';

import { useTheme } from "@mui/material/styles";

import { Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, TextField } from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import Pencil from '../assets/svg/pencil-outline.svg';

function ModifierTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

ModifierTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function ModifierDialogs(data) {

  const theme = useTheme();
  console.log(data);
  const creatures = data.inventaire;
  const left = data.left;
  const name = data.name;
  const dataToUpdate = data.dataToUpdate;
  const [open, setOpen] = React.useState(false);
  const [text, setText] = useState("");
  let newDatas = {};
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  console.log("creatures", creatures)

  const handleSave = () => {
    if (name === 'creature1') {
      newDatas = {
        creature1: text,
      };
    } else if (name === 'creature2') {
      newDatas = {
        creature2: text,
      };

    } else if (name === 'creature3') {
      newDatas = {
        creature3: text,
      };

    } else if (name === 'creature4') {
      newDatas = {
        creature4: text,
      };

    } else if (name === 'creature5') {
      newDatas = {
        creature5: text,
      };

    } else if (name === 'creature6') {
      newDatas = {
        creature6: text,
      };

    } else if (name === 'creature7') {
      newDatas = {
        creature7: text,
      };

    } else if (name === 'creature8') {
      newDatas = {
        creature8: text,
      };

    } else if (name === 'creature9') {
      newDatas = {
        creature9: text,
      };

    } else if (name === 'creature10') {
      newDatas = {
        creature10: text,
      };

    } else if (name === 'creature11') {
      newDatas = {
        creature11: text,
      };

    } else if (name === 'creature12') {
      newDatas = {
        creature12: text,
      };

    } else if (name === 'creature13') {
      newDatas = {
        creature13: text,
      };

    } else if (name === 'creature14') {
      newDatas = {
        creature14: text,
      };

    } else if (name === 'creature15') {
      newDatas = {
        creature15: text,
      };

    }
    console.log(newDatas);
    fetch(`/api/creatures/updateCreatures/${creatures.Name_character}`, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(newDatas),
    })
      .then(async (res) => {
        const body = await res.json().catch(() => null);
        if (!res.ok) throw new Error(`HTTP ${res.status}: ${JSON.stringify(body)}`);
        return body;
      })
      .then(() => {
        data.onCreatureUpdate?.(newDatas);
        setOpen(false);
      })
      .catch(console.error);
  }

  return (
    <div style={{ position: 'relative', height: '0px' }}>
      <Button sx={{ position: 'relative', display: 'flex', left: { left }, top: '-2.3vh', border: 'none' }} variant="outlined" onClick={handleClickOpen}>
        <img src={Pencil} color={theme.custom.mycustomblur.text} height={'15px'} alt="Modifier" id='modifier' />
      </Button>
      <Dialog
        onClose={handleClose}
        open={open}
        PaperProps={{ style: { minWidth: '30vw', minHeight: '30vh', backgroundColor: 'beige', color: "black" }, }}
      >
        <DialogTitle onClose={handleClose} sx={{ outerWidth: '50vw' }}>
          Entrez la nouvelle valeur de {dataToUpdate}
        </DialogTitle>
        <DialogContent>

          <div>
            <TextField autoFocus id="newCreatures" multiline sx={{ minHeight: '10vh', minWidth: '10vw', border: 'solid black 3px ' }} onChange={(e) => setText(e.target.value)} inputProps={{ style: { height: "150px", color: 'black' } }} />
            <Button onClick={() => {
              handleSave();
            }
            }> Save new value</Button>
          </div>
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog>
    </div>
  );
}